<div class="mb-4">
    <app-file-uploader #fileUploader [storage-strategy]="5" (uploadFinished)="onUploadFinished($event)"></app-file-uploader>
</div>